export default import.meta.ROLLUP_FILE_URL_BYZH3HR8;